import { milliseconds, ShapeName } from '@squaredup/data-streams';
import GraphTooltip from 'components/GraphTooltip';
import { computedTooltipPoints } from '../dataUtils';
import { BarSegment } from './types';

export const BarChartTooltip = ({
    hoveredBar,
    graphRef,
    displayMode,
    xAxisColumnShape,
    valueFormatter,
    xAxisTickFormatter
}: {
    hoveredBar: BarSegment;
    graphRef: React.RefObject<HTMLDivElement>;
    displayMode: 'actual' | 'cumulative' | 'percentage';
    xAxisColumnShape: ShapeName;
    valueFormatter: (value: number) => string;
    xAxisTickFormatter: (value: number) => string;
}) => {
    const { color, key, data } = hoveredBar;
    const value = data[key] as number;

    const formatted =
        displayMode === 'cumulative'
            ? valueFormatter(value)
            : xAxisColumnShape === milliseconds.name
            ? xAxisTickFormatter(value)
            : data[`${key}-formatted`];

    let subValue: string | undefined;

    if (displayMode === 'cumulative') {
        subValue = `+${data[`${key}-formatted`]}`;
    } else if (displayMode === 'percentage') {
        subValue = `${data[`${key}-percentage`]}`;
    }

    return (
        <GraphTooltip
            points={[
                computedTooltipPoints({
                    color,
                    id: key,
                    indexValue: data.__group__ ?? '',
                    formattedFromNivoData: formatted,
                    subValue,
                    columnShape: xAxisColumnShape
                })
            ]}
            graphRef={graphRef}
        />
    );
};
